import React from "react";

export interface ProductGuardrail {
  icon: React.ComponentType<{ className?: string }>;
  title: string;
  description: string;
}

interface Props {
  guardrails: readonly ProductGuardrail[];
  crossLink?: React.ReactNode;
}

export function ProductGuardrails({
  guardrails,
  crossLink,
}: Props): React.ReactElement {
  return (
    <section className="py-16 px-4">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl font-bold text-center mb-4">
          Safety &amp; <span className="text-primary">guardrails</span>
        </h2>
        <p className="text-center text-surface-foreground/80 mb-12 max-w-2xl mx-auto">
          Built for production infrastructure. Here's what Infralyst won't do.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {guardrails.map(({ icon: Icon, title, description }) => (
            <div
              key={title}
              className="p-6 rounded-3xl border bg-background/50 hover:border-primary/20 hover:bg-primary/5 transition-colors"
            >
              <div className="flex items-start gap-4">
                <div className="flex-none">
                  <div className="size-12 rounded-full bg-primary/10 text-primary flex items-center justify-center">
                    <Icon className="size-6" />
                  </div>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">{title}</h3>
                  <p className="text-surface-foreground/80 text-sm leading-relaxed">
                    {description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
        {crossLink !== undefined && (
          <p className="text-sm text-surface-foreground/60 text-center mt-8">
            {crossLink}
          </p>
        )}
      </div>
    </section>
  );
}
